import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Decimal from './Decimal';

const propTypes = {
    label: PropTypes.any,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    error: PropTypes.any,
    mandatory: PropTypes.bool,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    description: PropTypes.string,
    labelMode: PropTypes.string,
    currencySymbol: PropTypes.string,
};

const Currency = ({ className, currencySymbol = '', ...props }) => {
    return (
        <Decimal
            {...props}
            className={className || 'fm-field-currency'}
            hint="0.00"
            postComponent={currencySymbol ? <span>{currencySymbol}</span> : null}
        />
    );
};

Currency.displayName = 'Currency';
Currency.propTypes = propTypes;

export default memo(Currency);
